import { render } from "./AdminVerification.vue?vue&type=template&id=1b54ab0e&scoped=true"
import script from "./AdminVerification.vue?vue&type=script&lang=js"
export * from "./AdminVerification.vue?vue&type=script&lang=js"

import "./AdminVerification.vue?vue&type=style&index=0&id=1b54ab0e&lang=css"
import "./AdminVerification.vue?vue&type=style&index=1&id=1b54ab0e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b54ab0e"]])

export default __exports__